import { make } from 'vuex-pathify'

const getDefaultState = () => {
  return {
    token: null,
    loggedIn: false
  }
}
  
// initial state
const state = getDefaultState();

const actions = make.actions(state);

const mutations = make.mutations(state);

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};